import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Grid,
  GridColumn,
  GridPageChangeEvent,
  GridRowClickEvent,
} from "@progress/kendo-react-grid";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { Button } from "@progress/kendo-react-buttons";
import ApiServices from "../../service/apiService";
import { useNavigate } from "react-router-dom";
import {
  AllCourses,
  CoursesRecieved,
  HomeAdminAnalytics,
} from "@mikros/library";
import { Alert, CreateModal, Stats } from "@mikros/shared-ui";
import { CourseCard } from "../courses/courseCard";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";

export interface props {
  bgColor: string;
  count: number;
  stateText: String;
}

export function Home() {
  const navigate = useNavigate();
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  interface PageState {
    skip: number;
    take: number;
  }
  const initialDataState: PageState = { skip: 0, take: 5 };
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const [customerData, setCustomerData] = React.useState([]);
  const [homeAnalytics, setHomeAnalytics] = useState<HomeAdminAnalytics>(
    {} as HomeAdminAnalytics
  );
  const [visible, setVisible] = useState<boolean>(false);
  const [allCourses, setAllcourses] = useState<AllCourses>({
    resources: [{} as CoursesRecieved],
  } as AllCourses);

  const [goToParticularCourse, setGoToParticularCourse] =
    useState<boolean>(false);

  const [courseCount, setCourseCount] = useState(10);
  const [count, setCount] = useState(10);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const data = [
    {
      icon: "manualCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.manual",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAi",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiFileCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAiFromFile",
      })}`,
      disabled: false,
    },
    {
      icon: "catologueCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.fromCatalogue",
      })}`,
      disabled: true,
    },
  ];
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    //@ts-ignore
    const take =
      targetEvent.value === "All" ? customerData.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const toggleVisible = () => {
    setVisible(!visible);
  };

  async function homeAnalyticsApi() {
    console.log("entered home analytics");
    let api = ApiServices.getInstance();
    console.log("entered tenant id check");
    await api
      .makeRequest(`${accountInstance.accntId}/analyticsHome`, "GET")
      .then(async (res) => {
        if (res && res.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(res.errorMessage);
          return;
        }
        console.log("home analytics response", res);
        setHomeAnalytics(res);
      });
  }

  useEffect(() => {
    homeAnalyticsApi();
    apiGetCourse();
  }, []);

  useEffect(() => {
    const handleCourseResize = () => {
      if (window.innerWidth >= 1536) {
        setCourseCount(10);
        console.log("inside window width", count);
      } else if (window.innerWidth >= 1280 && window.innerWidth < 1536) {
        setCourseCount(10);
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1286) {
        setCourseCount(8);
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        setCourseCount(6);
      }
    };

    handleCourseResize();
    apiGetCourse();
  }, [goToParticularCourse, courseCount, accountInstance.accntId]);

  async function apiGetCourse() {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      await api
        .makeRequest(`${accountInstance.accntId}/course`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("Courses", res);
          let x = {
            ...res,
            resources: res.resources.filter(
              (course: CoursesRecieved) => course.status !== "ARCHIVED"
            ),
          } as AllCourses;
          x.resources.sort(
            (a, b) =>
              new Date(b.updatedAt!!).getTime() -
              new Date(a.updatedAt!!).getTime()
          );
          const top8Courses = x.resources.slice(0, courseCount);
          setAllcourses({
            resources: top8Courses.filter((course) => {
              return course.status !== "ARCHIVED";
            }),
            resourceCount: top8Courses.length,
          });
          console.log("top 2", res);
        });
    }
  }

  React.useEffect(() => {
    let api = ApiServices.getInstance();
    api.makeRequest("organization", "GET").then(async (data) => {
      if (data && data.errorMessage) {
        setErrorFlag(true);
        await errorInstance.updateErrorCode(data.errorMessage);
        return;
      }
      data.sort(sortBy);
      let sortedArray = data.slice(0, 5);
      setCustomerData(sortedArray);
    });
  }, []);

  const handleCreateCustomerClick = () => {
    navigate("/createCustomer/new");
  };

  const rowClick = (event: GridRowClickEvent) => {
    console.log(event);
    navigate("/createCustomer/" + event.dataItem.accntId);
  };

  const sortBy = (a: any, b: any) => {
    const dateC: any = b.dateCreated - a.dateCreated;
    return dateC;
  };

  const distributionCell = (props: any) => {
    const { email, teams, slack, whatsApp } = props.dataItem.distbAcc;
    return (
      <td className="k-command-cell">
        <div className="w-full flex mt-2 space-x-2 justify-start items-center">
          {whatsApp.enabled && (
            <img
              src={require(`../../assests/images/whatsapp.png`)}
              width={15}
              height={15}
            />
          )}
          {teams.enabled && (
            <img
              src={require(`../../assests/images/teams.png`)}
              width={15}
              height={15}
            />
          )}
          {slack.enabled && (
            <img
              src={require(`../../assests/images/slack.png`)}
              width={15}
              height={15}
            />
          )}
          {email.enabled && (
            <img
              src={require(`../../assests/images/email.png`)}
              width={15}
              height={15}
            />
          )}
        </div>
      </td>
    );
  };

  const handleViewAllCustomerClick = () => {
    navigate("/customer");
  };
  const handleviewAllCourseClick = () => {
    navigate("/courses");
  };
  const goToCreateCourse = (e: string) => {
    navigate("/createCourse", { state: e });
  };

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/home");
            }}
          />
        </Dialog>
      )}
      <div className="w-full h-full flex flex-col space-y-10 items-center">
        <div className="w-full flex flex-wrap justify-between items-center mt-2">
          <div className="pl-2 w-[25%]">
            <Stats
              data={homeAnalytics?.activeCustomers}
              value={intl.formatMessage({ id: "home.activeCustomers" })}
              bgColor={"mk-pink"}
            />
          </div>

          <div className="w-[25%]">
            <Stats
              data={homeAnalytics?.totalCustomers}
              value={intl.formatMessage({
                id: "home.totalCustomers",
              })}
              bgColor={"mk-orange"}
            />
          </div>

          <div className="w-[25%]">
            <Stats
              data={homeAnalytics?.totalCardSent}
              value={intl.formatMessage({
                id: "home.totalCardsSent",
              })}
              bgColor={"mk-blue"}
            />
          </div>

          <div>
            <Stats
              data={homeAnalytics?.actUsrPcent}
              value="Active User %"
              bgColor={"mk-green"}
            />
          </div>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div className="text-mk-primary-bright text-2xl mt-8 font-semibold">
          <FormattedMessage id="home.recentCustomers" />
        </div>

        <div className="flex mt-4 gap-4 ">
          <Button
            className="rounded bg-mk-primary-50 text-mk-primary-bright hover:bg-mk-light-grey
                                            hover:text-black focus:outline-none px-4 py-2"
            onClick={handleViewAllCustomerClick}
          >
            <FormattedMessage id="home.ViewAll" />
          </Button>

          <Button
            className="rounded bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
            onClick={handleCreateCustomerClick}
          >
            <FormattedMessage id="home.CreateCustomer" /> +
          </Button>
        </div>
      </div>
      <div className="mt-6">
        <div className="text-mk-primary-bright">
          <Grid
            style={{ border: 0 }}
            rowHeight={48}
            data={customerData.slice(page.skip, page.take + page.skip)}
            skip={page.skip}
            take={page.take}
            total={customerData.length}
            onPageChange={pageChange}
            className="cursor-pointer"
            onRowClick={rowClick}
          >
            <GridColumn
              field="organizationName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.customeGridName",
              })}
              cell={(props) => <td>{props.dataItem.organizationName}</td>}
            />
            <GridColumn
              field="legalName"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.LegalName",
              })}
              cell={(props) => <td>{props.dataItem.legalName}</td>}
            />
            <GridColumn
              field="email"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.EmailID",
              })}
              cell={(props) => <td>{props.dataItem.email}</td>}
            />
            <GridColumn
              field="phNo"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.MobileNumber",
              })}
              cell={(props) => <td>{props.dataItem.phNo}</td>}
            />
            <GridColumn
              field="status"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.Status",
              })}
              cell={(props) => <td>{props.dataItem.status}</td>}
            />
            <GridColumn
              field="level"
              title={intl.formatMessage({
                id: "searchCustomer.CustomerGrid.Distribution",
              })}
              width={140}
              cell={distributionCell}
            />
          </Grid>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <div className="text-mk-primary-bright text-2xl mt-8 font-semibold">
          <FormattedMessage id="home.recentCourses" />
        </div>

        <div className="flex mt-4 gap-4 ">
          {visible && (
            <CreateModal
              description={intl.formatMessage({
                id: "courses.modal.description",
              })}
              successText={intl.formatMessage({
                id: "courses.modal.successText",
              })}
              onCancel={() => setVisible(false)}
              onSuccess={(e: string) => goToCreateCourse(e)}
              data={data}
            />
          )}
          <Button
            className="rounded bg-mk-primary-50 text-mk-primary-bright hover:bg-mk-light-grey
                                            hover:text-black focus:outline-none px-4 py-2"
            onClick={handleviewAllCourseClick}
          >
            <FormattedMessage id="home.ViewAll" />
          </Button>

          <Button
            className="rounded bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
            onClick={toggleVisible}
          >
            <FormattedMessage id="home.CreateCourse" /> +
          </Button>
        </div>
      </div>

      <div className="pb-[2%]"></div>

      <div className="w-full h-full justify-between grid gap-y-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12 pb-[5%]">
        {allCourses.resources
          ?.filter((course) => {
            return course.status !== "ARCHIVED";
          })
          .map((ele, i) => {
            return (
              <CourseCard
                key={ele.courseId}
                backGroundImage={ele.thumbnailUrl!!}
                handleGoToCourse={(chptId: string) => {
                  navigate("/editCourse", {
                    state: JSON.stringify({
                      // name: <FormattedMessage id="courses.editCourse" />,
                      name: intl.formatMessage({id:"courses.editCourse"}),
                      data: chptId,
                    }),
                  });
                }}
                courseDetail={ele}
                onReload={() => {
                  apiGetCourse();
                }}
              />
            );
          })}
      </div>
      <div className="pb-[5%]"></div>
    </div>
  );
}
